import React from 'react'

import { ArcadeModalPortal, ArcadeModalPortalProps } from '@cash-design-system/react'

import { useModalSharedProps } from '../utils/useModalSharedProps'

export type ModalPortalProps = Omit<ArcadeModalPortalProps, 'ariaLabel' | 'closeButtonProps' | 'backButtonProps'> & {
  ariaLabel?: ArcadeModalPortalProps['ariaLabel']
  closeButtonProps?: Partial<ArcadeModalPortalProps['closeButtonProps']>
  backButtonProps?: Partial<ArcadeModalPortalProps['backButtonProps']>
}

export const ModalPortal = React.forwardRef<HTMLDivElement, ModalPortalProps>((props, ref) => {
  const sharedProps = useModalSharedProps(props)

  return <ArcadeModalPortal {...sharedProps} ref={ref} />
})

ModalPortal.displayName = 'SharedModalPortal'

export default ModalPortal
